import { render } from "./MenuTabsItem.vue?vue&type=template&id=3b01ea0c"
import script from "./MenuTabsItem.vue?vue&type=script&lang=js"
export * from "./MenuTabsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__